import React, { useRef } from "react";
import { NavLink } from "react-router-dom";
import "./DropdownButton.css";

const DropdownButton =(props)=>{
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const handleClick = (e) => {
    e.stopPropagation();

    const currentDropdown = dropdownRef.current;

    // Close any other open dropdowns
    document.querySelectorAll(".custom-dropdown").forEach((dropdown) => {
      if (dropdown !== currentDropdown) {
        dropdown.classList.remove("show");
        dropdown.querySelector(".custom-dropdown-toggle")?.classList.remove("show");
        dropdown.querySelector(".custom-dropdown-menu")?.classList.remove("show");
      }
    });

    // Toggle current dropdown
    currentDropdown.classList.toggle("show");
    buttonRef.current.classList.toggle("show");
    currentDropdown.querySelector(".custom-dropdown-menu")?.classList.toggle("show");
  };

  React.useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        dropdownRef.current.classList.remove("show");
        buttonRef.current.classList.remove("show");
        dropdownRef.current.querySelector(".custom-dropdown-menu")?.classList.remove("show");
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  const items = props.links;
  const id = props.did;

  const buttonLabel = props.lang === 'fr' ? props.titlefr : props.title;
  const renderText = (item) => props.lang === 'fr' ? item.textfr : item.text;
  const renderLink = (item) => props.lang === 'fr' ? item.linkFr : item.linkEn;

  return (
    <div id={id} className={`${props.class} custom-dropdown`} ref={dropdownRef}>
      <button type="button" id={`${id}-dropdownbutton`} className="btn custom-dropdown-toggle"  data-id={id} onClick={handleClick} ref={buttonRef}>{buttonLabel}</button>
      <div className="custom-dropdown-menu" >
      {
        items.map((item,i)=>(
          <NavLink key={i} to={renderLink(item)} rel={item.rel} target={item.target} className="custom-dropdown-item">{renderText(item)}</NavLink>
        ))
      }
      </div>
    </div>
  );
}

export default DropdownButton;
